import "reflect-metadata";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import routes from "@/config/Routes.tsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import PACKAGE from "../package.json";

console.info(`%c v${PACKAGE.version} / ${import.meta.env.VITE_BACKEND_HOST}`, "font-weight:bold;color:coral;font-size:20px");

const router = createBrowserRouter(routes);
createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>,
);
